module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.props) ? _c('section', {
    staticClass: "about-us",
    attrs: {
      "id": "about"
    }
  }, [_c('div', {
    staticClass: "about-us__title",
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.about.title)
    }
  }), _c('div', {
    staticClass: "about-us__team-container"
  }, _vm._l((_vm.props.acf.about.team), function(staff, i) {
    return _c('div', {
      key: i,
      staticClass: "about-us__team-member",
      class: {
        "about-us__team-member--active": i === _vm.$store.state.types
      },
      on: {
        "click": function($event) {
          _vm.showContent(i)
        },
        "mouseover": function($event) {
          _vm.showContent(i)
        }
      }
    }, [_c('Img', {
      staticClass: "about-us__image",
      class: "about-us__image--" + staff.name,
      attrs: {
        "src": staff.image,
        "alt": "staff"
      }
    })], 1)
  })), _c('div', {
    staticClass: "about-us__mobile-bio-container"
  }, [_c('transition-group', {
    staticClass: "about-us__bio-transition",
    attrs: {
      "name": "crossfade",
      "tag": "div"
    }
  }, _vm._l((_vm.props.acf.about.bio), function(bio, j) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (j === _vm.$store.state.types),
        expression: "j === $store.state.types"
      }],
      key: j,
      staticClass: "about-us__content-container"
    }, [_c('div', {
      staticClass: "about-us__col",
      domProps: {
        "innerHTML": _vm._s(bio.col_left)
      }
    }), _c('div', {
      staticClass: "about-us__col",
      domProps: {
        "innerHTML": _vm._s(bio.col_right)
      }
    })])
  })), _c('div', {
    staticClass: "about-us__office-btn",
    on: {
      "click": _vm.openOffice
    }
  }, [_c('span', [_vm._v("Tour the Office            ")])])], 1), _c('div', {
    staticClass: "about-us__bio-container"
  }, [_c('transition-group', {
    staticClass: "about-us__bio-transition",
    attrs: {
      "name": "crossfade",
      "tag": "div"
    }
  }, _vm._l((_vm.props.acf.about.bio), function(bio, j) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (j === _vm.$store.state.types),
        expression: "j === $store.state.types"
      }],
      key: j,
      staticClass: "about-us__content-container"
    }, [_c('div', {
      staticClass: "about-us__col",
      domProps: {
        "innerHTML": _vm._s(bio.col_left)
      }
    }), _c('div', {
      staticClass: "about-us__col",
      domProps: {
        "innerHTML": _vm._s(bio.col_right)
      }
    })])
  })), _c('div', {
    staticClass: "about-us__office-btn",
    on: {
      "click": _vm.openOffice
    }
  }, [_c('span', [_vm._v("Tour the Office")])]), _c('div', {
    staticClass: "about-us__arrow",
    on: {
      "click": function($event) {
        _vm.moveTo(3)
      }
    }
  }, [_c('Icon', {
    attrs: {
      "name": "arrow"
    }
  })], 1)], 1)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a601838e","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/sections/about-us/about-us.pug
// module id = 547
// module chunks = 1